<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">料號</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.requestNoStart" />

      <div class="input-group-prepend">
        <div class="input-group-text">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.ItemNoEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">品名規格</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.descriptionOrSpecification" />
    </div>

    <div class="list-group" style="text-align: left;">
      <template v-for="(item,index) in gridData">
        <div :key="item.ItemNo" class="list-group-item list-group-item-action">
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">
              <!-- <i class="fas fa-building"></i> -->
              料號: {{item.ItemNo}}
            </b>
            <!-- <h5
              class="badge badge-success"
              style="width:50%; 
              overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
     word-break: break-all;"
            >
              
            </h5>-->
          </div>
          <div>
            <h5 class="badge" style=" width:100%; text-align:left;
              overflow: hidden;">
              <span style="font-size:1rem;font-weight: 400; color:green;">
                <br />
                {{item.ItemDescription}}
              </span>
            </h5>
          </div>
          <div class="d-flex flex-row">
            <p class="mb-1 w-100" style="backgroun-color:#EEE;  word-break: break-all;">
              <span class="badge badge-light">庫存量:{{item.OnHandQuantity}}</span>
              <span class="badge badge-light">採購未入:{{item.PurchaseOrderQuantity}}</span>
              <span class="badge badge-light">製造未入:{{item.ManufacutreOrderQuantity}}</span>
              <span class="badge badge-light">受訂未出:{{item.CustomerOrderAllocated}}</span>
            </p>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">材料需求:{{item.MaterialRequireAllocated}}</span>
            <span class="badge badge-light">可用量:{{item.CanUseQuantity}}</span>
            <span class="badge badge-light">預訂出貨:{{item.OnDeliveryQuantity}}</span>
            <span class="badge badge-light">安全存量:{{item.SafetyStockQuantity}}</span>
          </div>

          <!-- <small v-if="item.Supplier" style="color:#888;float:right;">供應商: {{item.Supplier}}</small> -->
          <!-- <small style="float:right; color:#888;">
            <i class="fas fa-user"></i>
            {{form.EmployeeName}}
          </small>-->
        </div>
      </template>
    </div>
    <button @click="getData" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>
<script>
export default {
  name: "ItemMasterInquiry",
  data: function() {
    var data = {
      searchData: {
        companyId: this.$store.state.companyId,
        itemNoStart: "",
        itemNoEnd: "",
        descriptionOrSpecification: ""
      },
      gridData: []
    };
    return data;
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    getData: function() {
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/ItemMasterInquiry/Query", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    }
  }
};
</script>
<style lange="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}
input[type="date"] {
  padding: 0;
}
</style>